/* ==========================================================================
   Hero de la página About — mismo encaje que el hero de la Home: la composición
   de 1920×1080 se escala por ancho y el contenedor toma la altura resultante.
   ========================================================================== */

(function () {
  'use strict';

  function fit() {
    var roots = document.querySelectorAll('[data-about-hero="root"]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (window.innerWidth <= 1023) {
        root.style.removeProperty('--about-hero-scale');
        root.style.removeProperty('height');
        continue;
      }
      var scale = root.getBoundingClientRect().width / 1920;
      root.style.setProperty('--about-hero-scale', Math.round(scale * 10000) / 10000);
      root.style.height = Math.round(1080 * scale) + 'px';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fit);
  } else {
    fit();
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(fit, 120);
  });

  document.addEventListener('shopify:section:load', fit);
})();
